// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"34":"application","328":"admin","831":"education","882":"bio"}[chunkId] || chunkId) + "-" + {"34":"425d9023","239":"f8d454fd","328":"7aac7d32","831":"62776c94","882":"7aac7d32"}[chunkId] + ".css";
};